import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThisMonth = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "this-month-clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_15048",
			"data-name": "Rectangle 15048",
			width: 28.023,
			height: 24.338,
			fill: "none",
			stroke: "#7284fa",
			strokeWidth: 1
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_14552",
		"data-name": "Group 14552",
		transform: "translate(-336.064 -476.157)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_15236",
			"data-name": "Rectangle 15236",
			width: 50,
			height: 50,
			rx: 25,
			transform: "translate(336.064 476.157)",
			fill: "#dae9f7"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_10064",
			"data-name": "Group 10064",
			transform: "translate(-1043.675 576.09)",
			children: [/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_796",
				"data-name": "Ellipse 796",
				cx: 12,
				cy: 12,
				r: 12,
				transform: "translate(1394 -86)",
				fill: "#d9daee"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_10062",
				"data-name": "Group 10062",
				transform: "translate(3 32)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_10050",
					"data-name": "Group 10050",
					transform: "translate(1387.099 -118.271)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_9769",
						"data-name": "Group 9769",
						clipPath: "url(#this-month-clip-path)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_25313",
							"data-name": "Path 25313",
							d: "M.5,8.477l3.685,5.529,4.3-4.914",
							fill: "none",
							stroke: "#7284fa",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_25314",
							"data-name": "Path 25314",
							d: "M15.856,23.838A11.669,11.669,0,1,0,4.185,12.169v1.837",
							fill: "none",
							stroke: "#7284fa",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 1
						})]
					})
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group_10056",
					"data-name": "Group 10056",
					transform: "translate(1386.109 -120.102)",
					children: [
						/* @__PURE__ */ _jsx("g", {
							id: "Group_10053",
							"data-name": "Group 10053",
							transform: "translate(1 -4)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_10058",
								"data-name": "Group 10058",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_25528",
									"data-name": "Path 25528",
									d: "M14,22.5l-3.5,1,1-3.5L19,12.5,21.5,15Z",
									fill: "none",
									stroke: "#7284fa",
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 1
								})
							})
						}),
						/* @__PURE__ */ _jsx("line", {
							id: "Line_1055",
							"data-name": "Line 1055",
							x2: 2.5,
							y2: 2.5,
							transform: "translate(18.002 10.499)",
							fill: "none",
							stroke: "#7284fa",
							strokeLinejoin: "round",
							strokeWidth: 1
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_10055",
							"data-name": "Group 10055",
							transform: "translate(1 -4)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_10057",
								"data-name": "Group 10057",
								children: /* @__PURE__ */ _jsx("line", {
									id: "Line_1056",
									"data-name": "Line 1056",
									x2: 2.5,
									y2: 2.5,
									transform: "translate(11.5 20.001)",
									fill: "none",
									stroke: "#7284fa",
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 1
								})
							})
						})
					]
				})]
			})]
		})]
	})]
});
export default SvgThisMonth;
